import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=5281e76e&scoped=true"
import script from "./main-footer.vue?vue&type=script&lang=js"
export * from "./main-footer.vue?vue&type=script&lang=js"
import style0 from "./main-footer.vue?vue&type=style&index=0&id=5281e76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5281e76e",
  null
  
)

export default component.exports